module.exports = {
    totalWard: 12,
};
